import {
  BillingFieldsBaseEnum,
  CreditCardEnum,
} from '../checkout/billingInfo.ts';
import { AddressSelectOptions, BillingAddress } from '../shared/address.ts';

export enum PaymentMethodTypesEnum {
  Ach = 'ach',
  Card = 'card',
}

export const PAYMENT_METHOD_NICKNAME_MAX_LENGTH = 80;

export enum SupporterCCFieldsEnum {
  cardNumber = 'cardNumber',
  cardType = 'cardType',
  cvv = 'cvv',
  expirationDate = 'expirationDate',
  nameOnCard = 'nameOnCard',
  nickname = 'nickname',
}

export type SupporterCCDetails = BillingAddress & {
  type: PaymentMethodTypesEnum.Card;
  [SupporterCCFieldsEnum.cardNumber]: string;
  [SupporterCCFieldsEnum.cardType]: CreditCardEnum;
  [SupporterCCFieldsEnum.cvv]: string;
  [SupporterCCFieldsEnum.expirationDate]: string;
  [SupporterCCFieldsEnum.nameOnCard]: string;
  [SupporterCCFieldsEnum.nickname]?: string;
  [BillingFieldsBaseEnum.AddressOption]: string | AddressSelectOptions;
};

export enum SupporterAchFieldsEnum {
  accountName = 'accountName',
  accountNumber = 'accountNumber',
  nickname = 'nickname',
  routingNumber = 'routingNumber',
}

export type SupporterAchDetails = {
  type: PaymentMethodTypesEnum.Ach;
  [SupporterAchFieldsEnum.accountName]: string;
  [SupporterAchFieldsEnum.accountNumber]: string;
  [SupporterAchFieldsEnum.nickname]?: string;
  [SupporterAchFieldsEnum.routingNumber]: string;
};

export type SupporterPaymentMethodDetails = (
  | SupporterCCDetails
  | SupporterAchDetails
) & {
  // TODO this prob shouldn't be optional on the base object.
  id?: string;
  type: PaymentMethodTypesEnum;
};
